import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openPopup } from '../../features/cart/cartSlice';
import './SnackbarComponent.css'

export default function SnackbarComponent({ open }) {

    const dispatch = useDispatch()
    const [snackPack, setSnackPack] = useState([]);
    const [messageInfo, setMessageInfo] = useState(undefined);
    useEffect(() => {
        if (snackPack.length && !messageInfo) {
            setMessageInfo({ ...snackPack[0] });
            setSnackPack((prev) => prev.slice(1));
            dispatch(openPopup(true));
        } else if (snackPack.length && messageInfo && open) {
            dispatch(openPopup(false));
        }
    }, [snackPack, messageInfo, open, dispatch]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(openPopup(false));
    };

    const handleExited = () => {
        setMessageInfo(undefined);
    };
    return (
        <Snackbar
            key={messageInfo ? messageInfo.key : undefined}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            TransitionProps={{ onExited: handleExited }}
            message={messageInfo ? messageInfo.message : undefined}
            action={
                <React.Fragment>
                    <Button color="secondary" size="small" onClick={handleClose}>
                        <span className='text-white'>Product Added</span>
                    </Button>
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </React.Fragment>
            }
        />
    )
}
